import React from 'react';

/**
 * HST brand logo — uses /hst-logo.webp from /public.
 * Rendered inside a soft glowing ring so the white-background original PNG
 * blends naturally on the dark theme (no flashbang white square).
 */
export default function HSTLogo({ size = 32, className = '', withGlow = true }) {
  return (
    <div
      className={`inline-flex items-center justify-center rounded-full overflow-hidden ${withGlow ? 'ring-2 ring-accent/30 shadow-[0_0_20px_-4px_rgba(59,130,246,0.4)]' : ''} bg-white ${className}`}
      style={{ width: size, height: size, flexShrink: 0 }}
      aria-label="HST Game logo"
      data-testid="hst-logo"
    >
      <img
        src="/hst-logo.webp"
        alt="HST Game"
        width={size}
        height={size}
        className="w-full h-full object-contain"
        loading="eager"
        decoding="async"
      />
    </div>
  );
}
